import { render, staticRenderFns } from "./CreditChoice.vue?vue&type=template&id=531ba084&scoped=true"
import script from "./CreditChoice.vue?vue&type=script&lang=js"
export * from "./CreditChoice.vue?vue&type=script&lang=js"
import style0 from "./CreditChoice.vue?vue&type=style&index=0&id=531ba084&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531ba084",
  null
  
)

export default component.exports